import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { STATIC_CLASSES } from './Testimonial2.const'

export const useTestimonial2 = props => {
	const { metaData } = props

	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.image })

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	return [
		{
			image: metaData.image,
			mobileAlignment: metaData.mobileAlignment,
			rounding: metaData.imageRounding?.toNumber(),
			classes: STATIC_CLASSES,

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,
		},
		{ handleTextClick, handleImageClick, handleTextChange },
	]
}
